/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useEffect, useRef, useState } from "react";
//import ReCAPTCHA from "react-google-recaptcha";
import { ToastUtility } from "@syncfusion/ej2-notifications";

import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "../../contexts/CountryBrandApplicationContextProvider";
import { UIEvents } from "../../UIEvents";

function ContactPersonStep() {
	const { currentStep, formRef, countryBrandApplication, add, update } =
		useCountryBrandApplicationContext() as ICountryBrandApplicationContext;

	const {
		contactPersonName,
		contactPersonLastName,
		contactPersonPosition,
		contactPersonEmail,
		contactPersonPhone,
		uuid,
	} = countryBrandApplication;

	//const [reCAPTCHA, setReCAPTCHA] = useState(true);

	// function sendEmail(emailTo){
	// 	Email.send({
	// 		SecureToken: process.env.REACT_APP_SECURE_TOKEN_EMAIL,
	// 		To : emailTo,
	// 		From : "mail@mail.com",
	// 		Subject : `Ha comenzado una solicitud de Marca País ${uuid}`,
	// 		Body : `Ha comenzado una solicitud de Marca País ${uuid}`,
	// 	}).then(
	// 	  (message) => {
	// 		if(message === "OK"){
	// 			successShow("Se a enviado a su casilla de correo el identificador del formulario")
	// 		}
	// 	}
	// 	);
	// }

	// function dangerShow(msj: string) {
	// 	ToastUtility.show(msj, "Error", 4000);
	// }

	// function successShow(msj: string) {
	// 	ToastUtility.show(msj, "Success", 4000);
	// }

	useEffect(() => {
		function submitStepData() {
			const formElement = formRef.current as HTMLFormElement;
			const contactPersonName = formElement.elements.contactPersonName.value;
			const contactPersonLastName = formElement.elements.contactPersonLastName.value;
			const contactPersonPosition = formElement.elements.contactPersonPosition.value;
			const contactPersonEmail = formElement.elements.contactPersonEmail.value;
			const contactPersonPhone = formElement.elements.contactPersonPhone.value;

			if (countryBrandApplication.id === "-1") {
				//if (reCAPTCHA) {
				//sendEmail(contactPersonEmail)
				add({
					data: {
						contactPersonName,
						contactPersonLastName,
						contactPersonPosition,
						contactPersonEmail,
						contactPersonPhone,
						// lastStepCompleted: 0,
					},
					nextStep: currentStep + 1,
				});
				// } else {
				// 	dangerShow("Debe completar el reCAPTCHA");
				// }
			} else {
				update({
					data: {
						contactPersonName,
						contactPersonLastName,
						contactPersonPosition,
						contactPersonEmail,
						contactPersonPhone,
					},
					nextStep: currentStep + 1,
				});
			}
		}
		document.addEventListener(UIEvents.builtInFormValidateSucess, submitStepData);

		return () => {
			document.removeEventListener(UIEvents.builtInFormValidateSucess, submitStepData);
		};
	}, [countryBrandApplication]); //[countryBrandApplication, reCAPTCHA]
	// function onChange(value) {
	// 	value ? setReCAPTCHA(true) : setReCAPTCHA(false);
	// }

	return (
		<div className="step-page" id="step-1">
			<section>
				<h3>1 - Persona de contacto</h3>

				<label htmlFor="contactPersonName">
					<p>Nombre *</p>
					<input
						type="text"
						name="contactPersonName"
						id="contactPersonName"
						required
						defaultValue={contactPersonName}
					/>
				</label>
				<label htmlFor="contactPersonLastName">
					<p>Apellidos *</p>
					<input
						type="text"
						name="contactPersonLastName"
						id="contactPersonLastName"
						required
						defaultValue={contactPersonLastName}
					/>
				</label>
				<label htmlFor="contactPersonPosition">
					<p>Cargo</p>
					<input
						type="text"
						name="contactPersonPosition"
						id="contactPersonPosition"
						defaultValue={contactPersonPosition}
					/>
				</label>
				<label htmlFor="contactPersonEmail">
					<p>Email *</p>
					<input
						type="email"
						name="contactPersonEmail"
						id="contactPersonEmail"
						required
						defaultValue={contactPersonEmail}
					/>
				</label>
				<label htmlFor="contactPersonPhone">
					<p>Teléfono *</p>
					<input
						type="tel"
						name="contactPersonPhone"
						id="contactPersonPhone"
						required
						pattern="[0-9]+"
						title="Solo debe contener números"
						defaultValue={contactPersonPhone}
					/>
				</label>
				{/* {!countryBrandApplication.id && <ReCAPTCHA sitekey={process.env.REACT_APP_reCAPTCHA_KEY} onChange={onChange} />} */}
				<span className="span-message">
					Al completar este paso se le enviará un email con el código de solicitud creado.
				</span>
			</section>
		</div>
	);
}

export { ContactPersonStep };
